import html2pdf from "html2pdf.js";
import { buildHtml } from "./pdfReport";

function splitHtml(html) {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const css = [...doc.querySelectorAll("style")].map((s) => s.textContent).join("\n");
  return { css, body: doc.body.innerHTML };
}

function prepare(sessions, flips, cards, opts) {
  const from = [...sessions].map((s) => s.timestamp).sort()[0] ?? "";
  return buildHtml(sessions, opts, flips.filter((f) => f.timestamp >= from), cards);
}

function pdfWorker(sessions, flips, cards, opts, scale = 2, quality = 0.95) {
  const { css, body } = splitHtml(prepare(sessions, flips, cards, opts));
  const el = document.createElement("div");
  el.style.width = "1060px";
  el.innerHTML = `<style>${css.replace(/@page[^}]*}/, "")}</style>${body}`;
  const stamp = new Date().toISOString().slice(0, 10);
  return html2pdf()
    .set({
      margin: [10, 10, 10, 10],
      filename: `Triggerific-Pilot-${(opts.title || "Clinical Summary").replace(/\s+/g, "-")}-${stamp}.pdf`,
      image: { type: "jpeg", quality },
      html2canvas: { scale, useCORS: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
      pagebreak: { mode: ["css", "legacy"], avoid: "tr" },
    })
    .from(el);
}

export async function downloadPdf(sessions, flips, cards, opts) {
  await pdfWorker(sessions, flips, cards, opts).save();
}

export async function pdfDataUri(sessions, flips, cards, opts) {
  return pdfWorker(sessions, flips, cards, opts, 1.5, 0.85).outputPdf("datauristring");
}

export function printReport(sessions, flips, cards, opts) {
  const html = prepare(sessions, flips, cards, opts);
  const iframe = document.createElement("iframe");
  Object.assign(iframe.style, { position: "fixed", left: "-10000px", top: "0", width: "1123px", height: "794px", border: "0" });
  document.body.appendChild(iframe);
  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(html);
  doc.close();
  setTimeout(() => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    setTimeout(() => iframe.remove(), 1000);
  }, 500);
}
